export const microphonePublicationIsLive = (publication) => {
  const track = publication?.audioTrack;
  const mediaTrack = track?.mediaStreamTrack;
  return Boolean(
      track &&
      !publication.isMuted &&
      (!mediaTrack || mediaTrack.readyState === "live"),
  );
};

export const callerMicrophoneNeedsRecovery = ({
  callAnswered,
  microphoneWanted,
  publication,
}) => Boolean(
    callAnswered &&
    microphoneWanted &&
    !microphonePublicationIsLive(publication),
);
